export enum VisualizationCardType {
  Pie = "Pie",
  Bar = "Bar",
}
